// @ts-nocheck
import React from "react";
import { Field } from "src/components/Forms/Field";
import { FormikCheckbox } from "src/components/Forms/Checkbox";
import { ages } from "src/constants/account";
import { CheckboxStyle, RemoveIcon } from "../../../Wrapper";
import { FormikProps } from "formik";

interface Props {
  formProps: FormikProps<any>;
  clearFilterKey: (key: string) => void;
}

const Age: React.FC<Props> = ({ formProps, clearFilterKey }) => {
  let isVisible = false;

  if ((formProps?.values?.influencerAge || []).length > 0) {
    isVisible = true;
  }

  return (
    <Field
      label="Influencer Age:"
      mb={20}
      color="black"
      isBeside={true}
      extra={
        isVisible && (
          <RemoveIcon
            type="close-circle"
            onClick={() => {
              formProps?.setFieldValue("influencerAge", []);
              clearFilterKey("influencerAge");
            }}
            style={{ marginTop: "0px", marginLeft: "10px" }}
          />
        )
      }
      id="influencer_age"
    >
      <FormikCheckbox name="influencerAge" data={ages} style={CheckboxStyle} />
    </Field>
  );
};

export default Age;
